import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterLinksSection from './components/ClusterLinksSection';
import WhatIsConflict from './components/WhatIsConflict';
import ConflictCauses from './components/ConflictCauses';
import WhenToIntervene from './components/WhenToIntervene';
import ManagerMistakes from './components/ManagerMistakes';
import SkillsDeveloped from './components/SkillsDeveloped';
import PracticalSituations from './components/PracticalSituations';
import HowPracticeGoes from './components/HowPracticeGoes';
import FormatsSection from './components/FormatsSection';
import SuitableCompanies from './components/SuitableCompanies';
import HowProgramGoes from './components/HowProgramGoes';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function ConflictManagementPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по управлению конфликтами | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterLinksSection />
        <WhatIsConflict />
        <ConflictCauses />
        <WhenToIntervene />
        <ManagerMistakes />

        <div id="skills">
          <SkillsDeveloped />
        </div>

        <PracticalSituations />
        <HowPracticeGoes />
        <FormatsSection />
        <SuitableCompanies />

        <div id="process">
          <HowProgramGoes />
        </div>

        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <AboutTrainer />
        <FAQSection />
        <ReadNextSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}